// src/index.ts
import { OrderedList } from "@tiptap/extension-list";
import { OrderedList as OrderedList2 } from "@tiptap/extension-list";
var index_default = OrderedList;
export {
  OrderedList2 as OrderedList,
  index_default as default
};
//# sourceMappingURL=index.js.map